/**
 * @file
 * Behaviors for the Hero Banner.
 */
/* eslint-disable max-len */

(function(Drupal, $) {
  /**
   * Setup and attach the Hero Banner behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.sidebarMenu = {
    attach: function() {
      var $sidebarToggler = $('.subsite-sidebar-nav-mobile .navbar-toggler');

      $sidebarToggler.on('click', function() {
        $(this).toggleClass('collapsed');
        $(this)
          .parent('.subsite-sidebar-nav-mobile')
          .toggleClass('collapsed');
        var $sidebarList = $(this)
          .parents('.og-menu-container-mobile')
          .find('.sidebar-list');
        $sidebarList.toggle();
      });

      // The following event is triggered continuously
      // while we are resizing the window
      window.addEventListener('resize', function() {
        if (this.innerWidth < 992) {
          $sidebarToggler.removeClass('collapsed');
          $sidebarToggler
            .parent('.subsite-sidebar-nav-mobile')
            .removeClass('collapsed');
          $('.sidebar-list').hide();
        }
        else {
          $sidebarToggler.addClass('collapsed');
          $sidebarToggler
            .parent('.subsite-sidebar-nav-mobile')
            .addClass('collapsed');
          $('.sidebar-list').show();
        }
      });
    }
  };
})(Drupal, jQuery);
